import QueryService from '@/services/query'
import NotificationService from '@/services/notification'

import { VUE_APP_ROOT_API } from '@/helpers/env'
import StatusHelper from '@/helpers/status'
import i18n from '@/helpers/i18n'

export default {
  createBusiness: async function(name, region) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/businessapi/createbusiness`, JSON.stringify({ name, region }))
    return response
  },
  publishBusiness: async function(request, isRegistered) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/businessapi/publishbusiness`, JSON.stringify(request))

    var jsonResponse = await response.json()
    if (StatusHelper.isSuccess(response.status)) {
      if (!jsonResponse.ShowInvalidPasswordError && !jsonResponse.ShowGatheringRegistrationClosedError) {
        if (isRegistered) {
          NotificationService.showSuccess(i18n.t('success-publish-business'))
        } else {
          NotificationService.showSuccess(i18n.t('unpaid-business-publish-success-notification'))
        }
      }
    } else {
      NotificationService.showError(i18n.t('error-basic'))
    }

    return jsonResponse
  },
  unpublishBusiness: async function(request) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/businessapi/unpublishbusiness`, JSON.stringify(request))

    if (StatusHelper.isSuccess(response.status)) {
      NotificationService.showSuccess(i18n.t('success-unpublish-business'))
    } else {
      NotificationService.showError(i18n.t('error-basic'))
    }

    return await response.json()
  },
  getBusinessById: async function(id) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/businessapi/getbusinessbyid`, JSON.stringify({ id }))
    return await response.json()
  },
  getBusinessByIds: async function(ids) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/businessapi/getbusinessbyids`, JSON.stringify({ ids }))
    return await response.json()
  },
  getMyBusiness: async function() {
    const response = await QueryService.get(`${VUE_APP_ROOT_API}/businessapi/getmybusiness`)
    return await response.json()
  },
  updateBusiness: async function(request) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/businessapi/updatebusiness`, JSON.stringify(request))

    if (StatusHelper.isSuccess(response.status)) {
      NotificationService.showSuccess(i18n.t('success-update-business'))
    } else {
      NotificationService.showError(i18n.t('error-basic'))
    }

    return await response.json()
  },
  searchBusiness: async function(term) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/businessapi/searchbusiness`, JSON.stringify({ term }))

    if (!StatusHelper.isSuccess(response.status)) {
      NotificationService.showError(i18n.t('error-basic'))
      return []
    }

    return await response.json()
  },
  adminSearchBusiness: async function(term) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/businessapi/adminsearchbusiness`, JSON.stringify({ term }))

    if (!StatusHelper.isSuccess(response.status)) {
      NotificationService.showError(i18n.t('error-basic'))
      return []
    }

    return await response.json()
  },
  getBusinessesJSON: async function(showOnlyRegisteredBusinesses = false) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/businessapi/getbusinessesjson`, JSON.stringify({ showOnlyRegisteredBusinesses }))
    return await response.json()
  },
  downloadMyGatheringBusinessesReport: async function(filename) {
    await QueryService.download(`${VUE_APP_ROOT_API}/businessapi/getmygatheringbusinessesexcelreport`, filename)
  },
  unregisterBusiness: async function(request) {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/businessapi/unregisterbusiness`, JSON.stringify(request))

    if (StatusHelper.isSuccess(response.status)) {
      NotificationService.showSuccess(i18n.t('success-unregister-business'))
    } else {
      NotificationService.showError(i18n.t('error-basic'))
    }

    return await response.json()
  },
  deactivateAllBusinesses: async function() {
    const response = await QueryService.post(`${VUE_APP_ROOT_API}/businessapi/deactivateallbusinesses`)
    return await response.json()
  }
}
